import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';

import { LoggerService } from '../logger.service';
import { Individual } from '../model/individual';
import { LoginModel } from '../model/login.model';
import { LoginResult } from './login-result';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private http: HttpClient,
    private logger: LoggerService
  ) { }

  login(user: LoginModel): Observable<LoginResult> {
    const data = new FormData();
    data.append('password', user.Pass);

    const oberserable = this.http.post(`/pac-wizard/login/${user.Email}`, data);
    const shared = oberserable.pipe(map((result: any) => {
      const update: LoginResult = result;
      if (result.individual) {
        update.individual = new Individual(result.individual);
      }

      return update;
    }), share());

    shared.subscribe(result => {
      try {
        this.logger.info(result);

        if ('individual' in result && result.individual instanceof Individual && typeof ((window as any).H) === 'object') {
          (window as any).H.identify(result.individual.cst_recno.toString(), {
            name: result.individual.ind_full_name_cp,
            email: result.individual.eml_address,
            cst_member_flag: result.individual.cst_member_flag ? 'true' : 'false'
          });
        }
      } catch { }
    });

    return shared;
  }
}
